import React, { useEffect } from "react";

import {
  FiSquare,
  FiMove,
  FiZoomIn,
  FiZoomOut,
  FiTrash2,
  FiKey,
  FiEye,
  FiEyeOff,
} from "react-icons/fi";
import { FaUndo, FaLockOpen, FaLock } from "react-icons/fa";
import { TbCancel } from "react-icons/tb";

const RightBar = ({
  setTool,
  tool,
  zoomLevel,
  handleZoom,
  handleResetZoom,
  setRectangles,
  selectedRectForModal,
  setSelectedRectForModal,
  setShowRectModal,
  isLocked,
  setIsLocked,
  handleNull,
  setMaster,
  setShowSegments,
  showSegments
}) => {
  // Add keyboard shortcuts for tool selection
  useEffect(() => {
    const handleKeyPress = (e) => {
      const tag = e.target.tagName.toLowerCase();
      const isInput = tag === "input" || tag === "textarea";
      if (isInput) return;

      switch (e.key.toLowerCase()) {
        case "w":
          e.preventDefault();
          setTool("rectangle");
          break;
        case "a":
          e.preventDefault();
          setTool("move");
          break;
        case "e":
          e.preventDefault();
          setShowSegments((prev) => !prev);
          break;
        default:
          break;
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [setTool, setShowSegments]);

  // Add mouse wheel controls for zoom
  useEffect(() => {
    const handleWheel = (e) => {
      // Only handle if not in an input field and not holding any modifier keys
      const tag = e.target.tagName.toLowerCase();
      const isInput = tag === "input" || tag === "textarea";
      if (isInput || e.ctrlKey || e.shiftKey || e.altKey || e.metaKey) return;

      // Prevent page scrolling
      e.preventDefault();

      if (e.deltaY < 0) {
        // Wheel up - zoom in
        handleZoom("in");
      } else if (e.deltaY > 0) {
        // Wheel down - zoom out
        handleZoom("out");
      }
    };

    const handleMouseDown = (e) => {
      // Only handle middle button click and not in an input field
      const tag = e.target.tagName.toLowerCase();
      const isInput = tag === "input" || tag === "textarea";
      if (e.button === 1 && !isInput) {
        e.preventDefault();
        handleResetZoom();
      }
    };

    // Add event listeners to the whole document
    document.addEventListener('wheel', handleWheel, { passive: false });
    document.addEventListener('mousedown', handleMouseDown);

    return () => {
      document.removeEventListener('wheel', handleWheel);
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, [handleZoom, handleResetZoom]);

  return (
    <div className="w-16 bg-gray-100 p-2 border-l flex flex-col items-center space-y-4">
      <button
        onClick={() => setTool("move")}
        className={`p-2 rounded-md ${tool === "move" ? "bg-blue-200" : "hover:bg-gray-200"
          }`}
        title="Move/Zoom (A)"
      >
        <FiMove className="text-lg" />
      </button>

      <button
        onClick={() => setTool("rectangle")}
        className={`p-2 rounded-md ${tool === "rectangle" ? "bg-blue-200" : "hover:bg-gray-200"
          }`}
        title="Draw Rectangle (W)"
      >
        <FiSquare className="text-lg" />
      </button>
      <button
        onClick={setMaster}
        className={`p-2 rounded-md `}
        title="Set As Master"
      >
        <FiKey className="text-lg" />
      </button>
      <button
        onClick={() => setShowSegments(!showSegments)}
        className={`p-2 rounded-md `}
        title="Toggle Segments Visibility"
      >
        {
          showSegments ? <FiEyeOff className="text-lg" /> : <FiEye className="text-lg" />
        }

      </button>
      <button
        onClick={() => setIsLocked(!isLocked)}
        title="Lock The Boxes In Place"
        className={` p-2 rounded-md ${isLocked ? "bg-blue-200" : "hover:bg-gray-200"
          }`}
      >
        {isLocked ? (
          <FaLock className="text-lg" />
        ) : (
          <FaLockOpen className="text-lg" />
        )}
      </button>

      <div className="border-t border-gray-300 w-full"></div>
      {/* zoom control */}
      <div className="text-xs text-center text-gray-600">
        {Math.round(zoomLevel * 100)}%
      </div>
      <button
        onClick={() => handleZoom("in")}
        className="p-2 rounded-md hover:bg-gray-200"
        title="Zoom In"
      >
        <span className="text-lg">
          <FiZoomIn />
        </span>
      </button>

      <button
        onClick={() => handleZoom("out")}
        className="p-2 rounded-md hover:bg-gray-200"
        title="Zoom Out"
      >
        <span className="text-lg">
          <FiZoomOut />
        </span>
      </button>
      <button
        onClick={handleResetZoom}
        className="p-2 rounded-md hover:bg-gray-200"
        title="Reset Zoom"
      >
        <span className="text-lg">
          <FaUndo className="text-sm" />
        </span>
      </button>
      <button
        onClick={handleNull}
        className="p-2 rounded-md hover:bg-gray-200"
        title="Set as Null"
      >
        <span className="text-lg">
          <TbCancel className="text-md" />
        </span>
      </button>
      <button
        onClick={() => {
          if (selectedRectForModal) {
            setRectangles((prev) =>
              prev.filter((rect) => rect.id !== selectedRectForModal?.id)
            );
            setSelectedRectForModal(null);
            setShowRectModal(false);
          }
        }}
        disabled={!selectedRectForModal?.id}
        className="p-2 rounded-md hover:bg-gray-200 disabled:opacity-50"
        title="Delete Selected (Backspace)"
      >
        <FiTrash2 className="text-lg" />
      </button>
    </div>
  );
};

export default RightBar;

